import DiffInsured from 'components/summary/DiffInsured/container';

export default DiffInsured;
